'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function get(css) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

    return context.querySelectorAll(css);
}

var SearchResources = function () {
    function SearchResources() {
        _classCallCheck(this, SearchResources);

        this.searhQuery = '';
        this.categories = {};
        this._containerContent = get('section.resources .resources__content');
        this._content = get('section.resources .card-resources');
        this._showContent = get('section.resources .card-resources');
        this._searchField = get('.search__field');
        this._searchBtn = get('.search__btn');
        this._categoryItem = get('.aside-resources__box');
        this._clear = get('.aside-resources__reset');
        this._localHash = '';
        this.set = false;
    }

    _createClass(SearchResources, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.getSearch();
            this.getCategory();
            this.updateHash();
            this.clearFilter();
            this.updateResult();

            window.addEventListener('hashchange', function () {
                if (!_this.set) {
                    location.reload();
                }
            });
        }
    }, {
        key: 'eventClick',
        value: function eventClick(target, func) {
            target.addEventListener('click', func.bind(this));
        }
    }, {
        key: 'clearFilter',
        value: function clearFilter() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this._clear[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    this.eventClick(item, function (e) {
                        e.preventDefault();
                        this.searhQuery = '';
                        this._searchField[0].value = '';
                        for (var key in this.categories) {
                            for (var cat in this.categories[key]) {
                                if (cat == 'all') {
                                    this.categories[key][cat] = true;
                                } else {
                                    this.categories[key][cat] = false;
                                }
                            }
                        }
                        this.updateResult();
                        this.setHash();
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'getSearch',
        value: function getSearch() {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this._searchBtn[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    this.eventClick(item, function (e) {
                        e.preventDefault();
                        this.searhQuery = this._searchField[0].value;
                        this.setHash();
                        this.updateResult();
                    });
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: 'getCategory',
        value: function getCategory() {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = this._categoryItem[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var item = _step3.value;

                    var label = get('label[data-name]', item);

                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = label[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var itemLa = _step4.value;

                            if (!this.categories[item.getAttribute('data-type')]) this.categories[item.getAttribute('data-type')] = {};
                            if (itemLa.children[0].checked) this.categories[item.getAttribute('data-type')][itemLa.getAttribute('data-name')] = true;else this.categories[item.getAttribute('data-type')][itemLa.getAttribute('data-name')] = false;
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    this.eventClick(item, function (e) {
                        e.preventDefault();
                        var labelitem = void 0;

                        if (e.target.nodeName == 'LABEL') labelitem = e.target;else if (e.target.nodeName == 'DIV') return;else labelitem = e.target.parentNode;

                        if (labelitem) {
                            if (labelitem.children[0].checked) {
                                labelitem.children[0].checked = false;
                                this.updateCategory(labelitem.parentNode.getAttribute('data-type'), labelitem.getAttribute('data-name'));
                            } else {
                                labelitem.children[0].checked = true;
                                this.updateCategory(labelitem.parentNode.getAttribute('data-type'), labelitem.getAttribute('data-name'));
                            }

                            this.setHash();
                            this.updateResult();
                        }
                    });
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }, {
        key: 'updateCategory',
        value: function updateCategory(catO, findKey) {
            if (findKey == 'all' && this.categories[catO]['all']) {
                this.categories[catO]['all'] = !this.categories[catO]['all'];
            } else {
                if (findKey == 'all' && !this.categories[catO]['all']) {
                    for (var key in this.categories[catO]) {
                        if (key != 'all') this.categories[catO][key] = false;else this.categories[catO][key] = true;
                    }
                } else {
                    var activeAll = false;

                    this.categories[catO]['all'] = false;
                    this.categories[catO][findKey] = !this.categories[catO][findKey];

                    for (var _key in this.categories[catO]) {
                        if (this.categories[catO][_key]) activeAll = true;
                    }

                    if (!activeAll) this.categories[catO]['all'] = true;
                }
            }
        }
    }, {
        key: 'updateResult',
        value: function updateResult() {
            var hideType = 0;

            $('section.resources .card-resources').parent().hide();

            for (var type in this.categories) {

                for (var cat in this.categories[type]) {

                    if (type == 'topics') {

                        if (this.categories[type][cat]) {

                            if (cat == 'all') $(this._content).parent().show();

                            var _iteratorNormalCompletion5 = true;
                            var _didIteratorError5 = false;
                            var _iteratorError5 = undefined;

                            try {
                                for (var _iterator5 = this._content[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                    var card = _step5.value;

                                    var regType = new RegExp(type, "g");
                                    var regCat = new RegExp(cat, "g");

                                    if (regCat.exec(card.getAttribute('data-cat')) && regType.exec(card.getAttribute('data-type'))) $(card).parent().show();
                                }
                            } catch (err) {
                                _didIteratorError5 = true;
                                _iteratorError5 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                        _iterator5.return();
                                    }
                                } finally {
                                    if (_didIteratorError5) {
                                        throw _iteratorError5;
                                    }
                                }
                            }
                        }

                        this._showContent = $('section.resources .card-resources:visible');
                    } else {

                        if (!hideType) {
                            $(this._showContent).parent().hide();
                            hideType++;
                        }

                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;

                        try {
                            for (var _iterator6 = this._showContent[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                var _card2 = _step6.value;


                                if (this.categories[type][cat]) {
                                    if (cat == 'all') $(this._showContent).parent().show();

                                    var _regCat = new RegExp(cat, "g");

                                    if (_regCat.exec(_card2.getAttribute('data-cat'))) $(_card2).parent().show();
                                }
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }
                            } finally {
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }
                    }
                }
            }

            var regSearch = new RegExp(this.searhQuery.toLowerCase(), "g");
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = this._showContent[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {

                    
                    var _card3 = _step7.value;

                    if (!_card3.getAttribute('data-type')) {
                        continue
                    }

                    var title = regSearch.exec(_card3.getAttribute('data-title').toLowerCase());
                    var tag = regSearch.exec(get('.card-resources__tag', _card3)[0].innerHTML.toLowerCase());
                    var _type = regSearch.exec(_card3.getAttribute('data-type').toLowerCase().split('-').join(' '));
                    var _cat = regSearch.exec(_card3.getAttribute('data-cat').toLowerCase().split('-').join(' '));
                    var badge = void 0;

                    if (get('.card-resources__badge', _card3)[0]) badge = regSearch.exec(get('.card-resources__badge', _card3)[0].innerHTML.toLowerCase());else badge = false;

                    if (!title && !tag && !_type && !_cat && !badge) $(_card3).parent().hide();
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            for (var _type2 in this.categories) {
                for (var _cat2 in this.categories[_type2]) {
                    if (this.categories[_type2][_cat2]) {
                        if ($('.aside-resources__box[data-type*="' + _type2 + '"] [data-name="' + _cat2 + '"]')[0]) {
                            $('.aside-resources__box[data-type*="' + _type2 + '"] [data-name="' + _cat2 + '"]')[0].children[0].checked = true;
                        }
                    } else {
                        if ($('.aside-resources__box[data-type*="' + _type2 + '"] [data-name="' + _cat2 + '"]')[0]) {
                            $('.aside-resources__box[data-type*="' + _type2 + '"] [data-name="' + _cat2 + '"]')[0].children[0].checked = false;
                        }
                    }
                }
            }

            hideType = 0;
        }
    }, {
        key: 'updateHash',
        value: function updateHash() {
            var _this2 = this;

            var hash = this.getHash();

            if (hash.hashURLSearch) {
                this.searhQuery = this.dashToSpace(hash.hashURLSearch);
                this._searchField[0].value = this.dashToSpace(hash.hashURLSearch);
            }

            if (hash.hashURLfilter) {
                hash.hashURLfilter.split(',').forEach(function (element) {
                    _this2.categories['topics']['all'] = false;
                    _this2.categories['topics'][element] = !_this2.categories['topics'][element];
                });
            }

            if (hash.hashURLfilter) {
                hash.hashURLType.split(',').forEach(function (element) {
                    _this2.categories['resource-type']['all'] = false;
                    _this2.categories['resource-type'][element] = !_this2.categories['resource-type'][element];
                });
            }
        }
    }, {
        key: 'getHash',
        value: function getHash() {
            var hashURLSearch = void 0;
            var hashURLfilter = void 0;
            var hashURLType = void 0;

            if (location.hash) {
                hashURLSearch = location.hash.match(/search=(.*?)(&)/)[1];
                if (hashURLSearch == '&') hashURLSearch = '';
                hashURLfilter = location.hash.match(/filter=(.*?)(&)/)[1];
                hashURLType = location.hash.match(/type=(.*?)$/)[1];
            }

            this._localHash = hashURLSearch;
            return {
                hashURLSearch: hashURLSearch,
                hashURLfilter: hashURLfilter,
                hashURLType: hashURLType
            };
        }
    }, {
        key: 'setHash',
        value: function setHash() {
            var _this3 = this;

            var valSearch = this.spaceToDash(this.searhQuery);
            var valCat = [];
            var valType = [];

            for (var key in this.categories['topics']) {
                if (this.categories['topics'][key]) {
                    valCat.push(key);
                }
            }

            for (var _key2 in this.categories['resource-type']) {
                if (this.categories['resource-type'][_key2]) {
                    valType.push(_key2);
                }
            }

            valType = valType.join(',');
            valCat = valCat.join(',');

            this.set = true;
            window.location.hash = 'search=' + this.spaceToDash(this.searhQuery) + '&filter=' + valCat + '&type=' + valType;

            setTimeout(function () {
                return _this3.set = false;
            }, 100);
        }
    }, {
        key: 'spaceToDash',
        value: function spaceToDash(str) {
            return str.split(' ').join('_');
        }
    }, {
        key: 'dashToSpace',
        value: function dashToSpace(str) {
            return str.split('_').join(' ');
        }
    }]);

    return SearchResources;
}();

if (get('.resources__content')[0]) {
    var searchResources = new SearchResources();
    searchResources.init();
}


$('.aside-resources__title').click(function () {
    $('.aside-resources').toggleClass('is-hide');
});

// ========================
// 4. Active header local
// ========================

var headerLocal = $('.header-local');

if (headerLocal.length) {
    document.addEventListener('scroll', function () {

        if (!headerLocal[0].getBoundingClientRect().top) headerLocal.addClass('is-sticky');else headerLocal.removeClass('is-sticky');
    });
}


// ===============================
// 5. Active menu header local
// ===============================

if (headerLocal.length) {
    var headerLocalBurger = $('.header-local__burger');
    var headerLocalNav = $('.header-local__nav');
    var headerLocalNavDropdown = $('.header-local__nav .is-dropdown');
    var headerLocalNavDropdownItem = $('.header-local__nav .is-dropdown span');

    headerLocalBurger.on('click', function () {
        headerLocalBurger.toggleClass('is-show');
        headerLocalNav.slideToggle();
    });

    headerLocalNavDropdownItem.on('click', function () {
        headerLocalNavDropdown.toggleClass('is-show');
        $(this).parent().find('ul').slideToggle();
    });
}
